import { render, staticRenderFns } from "./EventPost.vue?vue&type=template&id=4b51252b&"
import script from "./EventPost.vue?vue&type=script&lang=js&"
export * from "./EventPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports